import { openobserveRum } from '@openobserve/browser-rum';
import { openobserveLogs } from '@openobserve/browser-logs';

export function initRum() {
    try {
        if (typeof window === 'undefined') return;

        // OPENOBSERVE_CLIENT_TOKEN is a public, write-only RUM token injected at build time.
        const clientToken = process.env.REACT_APP_OPENOBSERVE_CLIENT_TOKEN;
        if (!clientToken) return;

        const allowedTracingUrls = [
            {
                match: (url) => {
                    try {
                        const parsed = new URL(url, window.location.origin);
                        return parsed.origin === window.location.origin || /\.incruiter\.com$/i.test(parsed.hostname);
                    } catch (e) {
                        return false;
                    }
                },
                propagatorTypes: ['tracecontext', 'openobserve'],
            },
        ];

        const sharedConfig = {
            applicationId: 'frontend-mock',
            clientToken,
            site: 'monitor.incruiter.com',
            organizationIdentifier: 'default',
            service: 'frontend-mock',
            env: 'development',
            version: '0.0.1',
            insecureHTTP: false,
            apiVersion: 'v1',
        };

        openobserveRum.init({
            ...sharedConfig,
            trackResources: true,
            trackLongTasks: true,
            trackUserInteractions: true,
            sessionSampleRate: 100,
            sessionReplaySampleRate: 20,
            defaultPrivacyLevel: 'mask',
            allowedTracingUrls,
        });

        openobserveRum.startSessionReplayRecording();

        openobserveLogs.init({
            ...sharedConfig,
            forwardErrorsToLogs: true,
        });
    } catch (e) {
        try {
            console.warn('[RUM] Failed to initialize OpenObserve RUM', e);
        } catch (_) {
            // no-op
        }
    }
}
